import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import ContentPageTemplate from "../templates/contentpage.template"

const ContactPage = () => {
  let { contentfulContentPage } = useStaticQuery(graphql`
    query loadContactPage {
      contentfulContentPage(title: { eq: "CONTACT STAFFORD LOCKSMITH LLC" }) {
        title
        mainContent {
          json
        }
        secondaryContent {
          json
        }
        slider {
          images {
            description
            fluid {
              src
            }
          }
        }
        images {
          fluid {
            src
          }
        }
        images2 {
          fluid {
            src
          }
        }
        asideText {
          json
        }
        mapAside {
          map: mapAside
        }
      }
    }
  `)
  return <ContentPageTemplate pageContext={{ ...contentfulContentPage }} />
}

export default ContactPage
